<script setup lang="ts">
import { CoreEventSource } from '@apps/main/new-desktop/core/models';
import {
  useBrowserStore,
  useRecipeStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { SemboDate } from '@libs/sembo-dates';

import { usePeekPriceStore } from '../stores';

import PeekPriceModalDesktop from './PeekPriceModalDesktop.vue';
import PeekPriceModalMobile from './PeekPriceModalMobile.vue';

interface PeekPriceModalEmits {
  (eventName: 'cancel'): void;
  (eventName: 'confirm'): void;
}

const emit = defineEmits<PeekPriceModalEmits>();

const browserStore = useBrowserStore();
const peekPriceStore = usePeekPriceStore();
const statsigEventsStore = useStatsigEventsStore();
const recipeStore = useRecipeStore();

function onSelectDate(date: Date): void {
  statsigEventsStore.logHotelSelectionPeekPriceModalDateSelected();
  statsigEventsStore.logCoreDateChanged({
    source: CoreEventSource.HotelSelection,
  });

  if (new SemboDate(date).isAtLeastOneYearAhead()) {
    statsigEventsStore.logCoreDateSelectedAtLeastOneYearAhead({
      totalIngredients: recipeStore.recipeWithoutUnknownOwnTransport.length,
      totalAccomodation: recipeStore.hotelOnlyRecipe.length,
      totalOwnStay: recipeStore.ownStayOnlyRecipe.length,
      totalFlight: recipeStore.flightOnlyRecipe.length,
      totalFerry: recipeStore.ferryOnlyRecipe.length,
      totalUnbookableTransport:
        recipeStore.unbookableTransportOnlyRecipe.length,
      totalActivity: recipeStore.activityOnlyRecipe.length,
    });
  }

  peekPriceStore.preselectDate(date);
}

function onSelectMonth(date: Date): void {
  statsigEventsStore.logHotelSelectionPeekPriceModalMonthSelected();
  peekPriceStore.selectMonth(date);
}
</script>

<template>
  <template v-if="peekPriceStore.itinerary">
    <PeekPriceModalMobile
      v-if="browserStore.isSmallerThan900px"
      :calendar="peekPriceStore.calendar"
      :itinerary="peekPriceStore.itinerary"
      @cancel="emit('cancel')"
      @confirm="emit('confirm')"
      @select-date="onSelectDate"
      @select-month="onSelectMonth"
    />

    <PeekPriceModalDesktop
      v-else-if="browserStore.isLargerThan899px"
      :itinerary="peekPriceStore.itinerary"
      :calendar="peekPriceStore.calendar"
      @cancel="emit('cancel')"
      @confirm="emit('confirm')"
      @select-date="onSelectDate"
      @select-month="onSelectMonth"
    />
  </template>
</template>
